// Componentes visuais compartilhados entre as abas (Card de info, Linha de
// 2 colunas, KPI métrica). Wrappers finos sobre Antd pra preservar API antiga
// (Wave 2 — 2026-06-01).

import React from 'react';
import { Card as AntCard, Typography, Progress } from 'antd';

export function Card({ titulo, children, coluna2 }: { titulo: string; children: React.ReactNode; coluna2?: boolean }) {
  return (
    <AntCard size="small"
      styles={{ body: { padding: 14 } }}
      title={titulo ? (
        <Typography.Text strong style={{
          fontSize: 12, color: '#020D7F',
          textTransform: 'uppercase', letterSpacing: 0.5,
        }}>{titulo}</Typography.Text>
      ) : undefined}
      style={{ gridColumn: coluna2 ? 'span 2' : 'span 1' }}>
      {children}
    </AntCard>
  );
}

export function Linha({ r, v }: { r: string; v: any }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: 6,
      padding: '4px 0', fontSize: 12, color: '#222' }}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>{r}</Typography.Text>
      <span>{v || <Typography.Text type="secondary">—</Typography.Text>}</span>
    </div>
  );
}

export function KPI({ titulo, valor, sub, cor }: { titulo: string; valor: string; sub?: string; cor?: string }) {
  return (
    <div>
      <Typography.Text type="secondary" style={{
        fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5,
      }}>{titulo}</Typography.Text>
      <div style={{ fontSize: 18, fontWeight: 700, color: cor || '#020D7F', marginTop: 4 }}>{valor}</div>
      {sub && <Typography.Text type="secondary" style={{ fontSize: 10, display: 'block', marginTop: 2 }}>{sub}</Typography.Text>}
    </div>
  );
}

// Barra de progresso — wrapper sobre Progress Antd preservando assinatura antiga.
export function BarraProgresso({ pct }: { pct: number }) {
  const p = Math.max(0, Math.min(100, pct));
  const strokeColor = p === 100 ? '#0a7f4a' : p >= 50 ? '#0930D0' : '#B07500';
  return (
    <Progress percent={p} size="small" strokeColor={strokeColor}
      format={(v) => <Typography.Text style={{ fontSize: 10, color: '#666' }}>{v}%</Typography.Text>} />
  );
}
